<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Avstånd & Rundning
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Sajten följer ett 4 px grid. Rundningsradier är konsistenta per
      komponenttyp.
    </p>

    <p
      class="font-[Poppins] font-bold text-[11px] text-teal-500 tracking-[1.2px] uppercase mb-3"
    >
      Rundningsradie
    </p>
    <div class="flex flex-wrap gap-3 mb-8">
      <div
        v-for="r in radii"
        :key="r.label"
        class="flex flex-col items-center gap-2"
      >
        <div
          class="w-14 h-14"
          :style="{
            background: 'rgba(20,184,166,0.12)',
            border: '2px solid #14b8a6',
            borderRadius: r.px,
          }"
        />
        <span class="font-mono text-[10px] text-[#6c7a77] text-center">{{
          r.px
        }}</span>
        <span
          class="font-[Plus_Jakarta_Sans] text-[10px] text-[#a0b0ae] text-center max-w-[70px]"
          >{{ r.used }}</span
        >
      </div>
    </div>

    <p
      class="font-[Poppins] font-bold text-[11px] text-teal-500 tracking-[1.2px] uppercase mb-3"
    >
      Spacing-skala (4 px grid)
    </p>
    <div class="flex items-end gap-1.5 flex-wrap">
      <div
        v-for="s in spacingScale"
        :key="s"
        class="flex flex-col items-center gap-1"
      >
        <div
          class="w-6 rounded-[4px]"
          :style="{ height: s + 'px', background: 'rgba(20,184,166,0.2)' }"
        />
        <span class="font-mono text-[9px] text-[#a0b0ae]">{{ s }}</span>
      </div>
    </div>
    <CodeBlock :code="code" />
  </div>
</template>

<script setup>
import CodeBlock from "../components/CodeBlock.vue";

const radii = [
  { label: "rounded-xl", px: "12px", used: "Knappar, taggar" },
  { label: "rounded-2xl", px: "16px", used: "Receptkortsbilder" },
  { label: "rounded-3xl", px: "24px", used: "Kort, paneler" },
  { label: "rounded-[40px]", px: "40px", used: "Ingredienspaneler" },
  { label: "rounded-[48px]", px: "48px", used: "Hero-bild" },
  { label: "rounded-full", px: "999px", used: "Pills, avatar" },
];
const spacingScale = [4, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80, 96];

const code = `<!-- Radie-system -->
<div class="rounded-xl">  <!-- 12px — knappar, taggar --></div>
<div class="rounded-2xl"> <!-- 16px — receptkortsbilder --></div>
<div class="rounded-3xl"> <!-- 24px — kort, paneler --></div>
<div class="rounded-[40px]"><!-- 40px — ingredienspaneler --></div>
<div class="rounded-full"> <!-- pill — badges, avatars --></div>

<!-- Spacing använder 4 px-grid -->
<!-- gap-1 (4px), gap-2 (8px), gap-3 (12px), gap-4 (16px) -->
<!-- p-3 (12px), p-4 (16px), p-5 (20px), p-6 (24px) -->`;
</script>
